export const SETTINGS_FONT_SIZE = 'SETTINGS_FONT_SIZE'
export const SETTINGS_FONT_LINE = 'SETTINGS_FONT_LINE'
export const SETTINGS_FONT_ALIGN = 'SETTINGS_FONT_ALIGN'
export const SETTINGS_THEME = 'SETTINGS_THEME'

export const SONGS_CURRENT = 'SONGS_CURRENT'
export const SONGS_CURRENT_CLEAR = 'SONGS_CURRENT_CLEAR'
export const SONGS_SEARCH = 'SONGS_SEARCH'
export const SONGS_SEARCH_CLEAR = 'SONGS_SEARCH_CLEAR'
